// レポート情報の定義
export const reports = {
  wp01: {
    title: '「検討します」を「申し込みます」に変える魔法の一言',
    subtitle: '購入検討者の心理を理解し、クロージング率を3倍にする実践的テクニック',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '1.16MB',
    image: '/images/wp01-thumb.png'
  },
  wp02: {
    title: '初回面談30分で専任媒介を獲得する面談シート',
    subtitle: '時間配分から質問の流れまで、成功率87%の面談手法を完全公開',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.3MB',
    image: '/images/wp02-thumb.png'
  },
  wp03: {
    title: '年収を聞かずに予算を把握する7つの質問術',
    subtitle: 'お客様との関係を壊さずに、正確な予算を把握する心理テクニック',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '1.8MB',
    image: '/images/wp03-thumb.png'
  },
  wp04: {
    title: '購入検討者の心理段階別アプローチ法',
    subtitle: 'お客様の心理状態を見極め、最適なタイミングで最適な提案をする方法',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.5MB',
    image: '/images/wp04-thumb.png'
  },
  wp05: {
    title: '成約率を上げる物件案内チェックリスト',
    subtitle: 'プロが実践する物件案内の極意！案内前・案内中・案内後の完全ガイド',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '3.2MB',
    image: '/images/wp05-thumb.png'
  },
  wp06: {
    title: '購入申込を獲得する交渉術',
    subtitle: '売主・買主の間で「三方よし」を実現する価格交渉とクロージングの極意',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.8MB',
    image: '/images/wp06-thumb.png'
  },
  wp07: {
    title: '「他社も見ています」と言われた時の切り返し話法20選',
    subtitle: '競合に負けない心理テクニックと信頼構築の極意',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.1MB',
    image: '/images/wp07-thumb.png'
  },
  wp08: {
    title: '内見後に音信不通になった客を復活させる3通のLINE',
    subtitle: '心理学に基づいた復活率78%のメッセージ術',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '1.9MB',
    image: '/images/wp08-thumb.png'
  },
  wp09: {
    title: 'ローン事前審査を初回面談で通す5ステップ',
    subtitle: '成功率85%の時短営業術',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.0MB',
    image: '/images/wp09-thumb.png'
  },
  wp10: {
    title: '内見3件以内で決める！事前ヒアリング完全ガイド',
    subtitle: '効率的な物件案内で成約率90%を実現',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.2MB',
    image: '/images/wp10-thumb.png'
  },
  wp11: {
    title: '購入申込書の記入率を80%に上げる心理テクニック',
    subtitle: 'その場で決断させる極意と実践的アプローチ',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.1MB',
    image: '/images/wp11-thumb.png'
  },
  wp12: {
    title: '仲介手数料半額と言われた時の価値の伝え方',
    subtitle: '手数料以上の価値を感じてもらう7つの話法',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.0MB',
    image: '/images/wp12-thumb.png'
  },
  wp13: {
    title: 'ポータルからの反響を来店に繋げる返信テンプレート集',
    subtitle: '反響からの来店率を3倍にする実践的メール術',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.1MB',
    image: '/images/wp13-thumb.png'
  },
  wp14: {
    title: '購入客が本当に知りたい10の質問と模範回答',
    subtitle: '顧客心理を理解した完璧な回答術',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '1.8MB',
    image: '/images/wp14-thumb.png'
  },
  wp15: {
    title: '信頼を勝ち取る車内トーク術',
    subtitle: '限られた移動時間を最強の営業タイムに変える方法',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.2MB',
    image: '/images/wp15-thumb.png'
  },
  wp16: {
    title: '住宅ローン通らない客を通す裏ワザ15選',
    subtitle: '諦めていた顧客を救う実践的アプローチ',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.5MB',
    image: '/images/wp16-thumb.png'
  },
  wp17: {
    title: '内見中やってはいけないNG行動ワースト10',
    subtitle: 'せっかくの物件を台無しにしない内見術',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '1.4MB',
    image: '/images/wp17-thumb.png'
  },
  wp18: {
    title: '購入決断を1週間早める緊急性演出法',
    subtitle: '適切なプレッシャーで背中を押す技術',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '1.5MB',
    image: '/images/wp18-thumb.png'
  },
  wp19: {
    title: '購入検討者の家族を味方につける方法',
    subtitle: '配偶者・親族の反対を賛成に変える話法',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.4MB',
    image: '/images/wp19-thumb.png'
  },
  wp20: {
    title: '競合他社に勝つ！差別化戦略10選',
    subtitle: '大手に負けない地場企業の強みの作り方',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.6MB',
    image: '/images/wp20-thumb.png'
  },
  wp21: {
    title: '購入仲介でも両手が狙える！売主開拓の極意',
    subtitle: '買主から売主を見つける逆転の発想',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.7MB',
    image: '/images/wp21-thumb.png'
  },
  wp22: {
    title: '価格交渉を成功させる売主への伝え方',
    subtitle: '値下げ交渉の成功率を90%にする心理術',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.3MB',
    image: '/images/wp22-thumb.png'
  },
  wp23: {
    title: '長期検討客を今すぐ客に変える方法',
    subtitle: '購入タイミングを引き寄せる7つのテクニック',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.2MB',
    image: '/images/wp23-thumb.png'
  },
  wp24: {
    title: 'シングルマザー・ファザーの住宅購入支援ガイド',
    subtitle: 'ひとり親家庭の夢のマイホーム実現をサポートする方法',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.5MB',
    image: '/images/wp24-thumb.png'
  },
  wp25: {
    title: '購入仲介で使える最新IT活用術',
    subtitle: 'VR内見・AI査定・自動追客システムの導入法',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '3.8MB',
    image: '/images/wp25-thumb.png'
  },
  wp26: {
    title: 'オンライン商談で成約率を上げる方法',
    subtitle: '対面営業と同等以上の成果を出すテクニック',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.6MB',
    image: '/images/wp26-thumb.png'
  },
  wp27: {
    title: '初対面で信頼を築く話法',
    subtitle: '心理学に基づいた最速信頼構築テクニック',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.2MB',
    image: '/images/wp27-thumb.png'
  },
  wp28: {
    title: 'オンライン接客で売る！画面越しの信頼構築術',
    subtitle: 'ZOOMで成約率40%を実現する方法',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.8MB',
    image: '/images/wp28-thumb.png'
  },
  wp29: {
    title: '引っ越し業者紹介で副収入！年間300万円の作り方',
    subtitle: '購入仲介の付帯サービスで収益アップ',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.4MB',
    image: '/images/wp29-thumb.png'
  },
  wp30: {
    title: '週末3日で月収100万！効率的な営業手法',
    subtitle: '時間を最大活用する週末集中営業の極意',
    language: '日本語',
    fileType: 'PDF',
    fileSize: '2.7MB',
    image: '/images/wp30-thumb.png'
  }
};